import { render, staticRenderFns } from "./CommunityMemberVirtualItem.vue?vue&type=template&id=1b4e0ca9&scoped=true"
import script from "./CommunityMemberVirtualItem.vue?vue&type=script&lang=js"
export * from "./CommunityMemberVirtualItem.vue?vue&type=script&lang=js"
import style0 from "./CommunityMemberVirtualItem.vue?vue&type=style&index=0&id=1b4e0ca9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4e0ca9",
  null
  
)

export default component.exports